module.exports = __webpack_public_path__ + "app/modals/confirm-message.view.html";